export default __webpack_public_path__ + "static/media/715.e1915410.gif";